// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { getElement } from '../element/selectors/elementSelector';
import { getIsElementClipboardCutSelector } from '../workspace/shortcuts/clipboard/clipboardSelectors';

// Components
import Element from '../element/Element';

// Styles
import './ListElement.scss';

const mapStateToProps = () =>
    createStructuredSelector({
        element: getElement,
        isElementCut: getIsElementClipboardCutSelector,
    });

const ListElementPresentational = (props) => {
    // If the element has been cut, don't render anything
    if (props.isElementCut) return null;

    return (
        <div className="ListElement">
            {props?.ElementComponent ? <props.ElementComponent {...props} /> : <Element {...props} />}
        </div>
    );
};

ListElementPresentational.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    ElementComponent: PropTypes.element,
    isElementCut: PropTypes.bool,
};

export default connect(mapStateToProps)(ListElementPresentational);
